// src/pages/Login.jsx
import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    if (login(email, password)) navigate("/");
    else alert(t("login.error"));
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>{t("login.title")}</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-group">
            <input 
              type="email" 
              placeholder={t("login.email_placeholder")} 
              value={email}
              onChange={e => setEmail(e.target.value)}
              required 
            />
          </div>
          <div className="input-group">
            <input 
              type="password" 
              placeholder={t("login.password_placeholder")} 
              value={password}
              onChange={e => setPassword(e.target.value)}
              required 
            />
          </div>
          <button type="submit" className="auth-btn">
            {t("login.submit")}
          </button>
        </form>
        
        <p className="auth-footer">
          {t("login.no_account")}{' '}
          <Link to="/register">{t("login.register_link")}</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;